import styled from 'styled-components';

const HoverImage = styled.img`
  height: 321px;
  width: auto;
  background: white;
  margin-top: 7px;
`;

const HoverImageColumn = styled.div`
  display: flex;
  padding-top: 20px;
  flex-direction: column;
  margin-left: ${({ marginLeft }) => marginLeft};
  margin-right: ${({ marginRight }) => marginRight};
`;

export { HoverImage, HoverImageColumn };
